var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action, observable } from 'mobx';
import { listUsers } from '@gtintel/platform-api';
const defaultFetchUserListParams = {
  limit: 10,
  offset: 0,
  search: '',
  tags: ''
};
let AdminMessageStore = (_class = class AdminMessageStore {
  constructor(rootStore) {
    this.rootStore = void 0;
    _initializerDefineProperty(this, "isLoading", _descriptor, this);
    _initializerDefineProperty(this, "hasMore", _descriptor2, this);
    _initializerDefineProperty(this, "currentUserListParams", _descriptor3, this);
    _initializerDefineProperty(this, "userList", _descriptor4, this);
    this.rootStore = rootStore;
  }
  async fetchMoreUsers(pageSize = 10) {
    this.isLoading = true;
    this.currentUserListParams.offset += pageSize;
    const response = await listUsers(this.currentUserListParams);
    // this.userList = this.userList.concat(response.results);
    this.userList = [...this.userList, ...response.results];
    if (!response?.next) {
      this.hasMore = false;
    }
    this.isLoading = false;
  }
  async refetchUsers(isNew = false) {
    this.isLoading = true;
    if (isNew) {
      this.currentUserListParams = {
        ...defaultFetchUserListParams
      };
    }
    const response = await listUsers(this.currentUserListParams);
    this.userList = response.results;
    if (!response?.next) {
      this.hasMore = false;
    }
    this.isLoading = false;
  }
  async changeSearchText(keyword) {
    this.currentUserListParams = {
      ...defaultFetchUserListParams,
      search: keyword
    };
    this.refetchUsers();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isLoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "hasMore", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "currentUserListParams", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {
      ...defaultFetchUserListParams
    };
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "userList", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "fetchMoreUsers", [action], Object.getOwnPropertyDescriptor(_class.prototype, "fetchMoreUsers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "refetchUsers", [action], Object.getOwnPropertyDescriptor(_class.prototype, "refetchUsers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "changeSearchText", [action], Object.getOwnPropertyDescriptor(_class.prototype, "changeSearchText"), _class.prototype), _class);
export { AdminMessageStore as default };